export const formatRelativeTime = (timestamp: number): string => {
  const diff = Math.floor((Date.now() - timestamp) / 1000)
  if (diff < 60) return "il y a quelques secondes"
  if (diff < 3600) return `il y a ${Math.floor(diff / 60)} min`
  if (diff < 86400) return `il y a ${Math.floor(diff / 3600)}h`
  return `il y a ${Math.floor(diff / 86400)}j`
}
